"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregateRatingSchema = void 0;
const getAggregateRatingSchema = (rating, ratingCount) => {
    if (!rating || !ratingCount) {
        return undefined;
    }
    return {
        aggregateRating: {
            '@type': 'AggregateRating',
            bestRating: '5',
            ratingValue: rating,
            reviewCount: ratingCount,
        },
    };
};
exports.getAggregateRatingSchema = getAggregateRatingSchema;
//# sourceMappingURL=rating-schema.js.map